import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {IMyOptions} from "mydatepicker";
import {companyVisa} from "../type/company-visa";


@Component({
    selector: 'app-company-visa-edit',
    templateUrl: './company-visa-edit.component.html',
})
export class CompanyVisaEditComponent implements OnInit {

    node = 'company-visa';
    usersNode = 'user';
    visaStatusNode = 'visa-status';
    CompanyVisa: companyVisa = companyVisa;

    users = [{}];
    //company = {};

    visaStatuses = [{}];

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
         // dateFormat: 'yyyy-mm-dd',
    };
    text: string;

    results: [{}];

    constructor(
        private apiService: ApiService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private location: Location,
    ) {
    }


    ngOnInit(): void {
        this.dataService.refresh();
        this.getUsers();
        this.getVisaStatuses();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.CompanyVisa = response.json().data[0]
                        });
                }
            );
    }


    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [{}];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getVisaStatuses() {
        this.apiService.getAll(this.visaStatusNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.visaStatuses = [{}];
                    } else {
                        this.visaStatuses = response.json().data;
                        console.log(this.visaStatuses);
                    }
                },
                (error) => {this.visaStatuses = [{}];}
            );
    }




    onFormSubmit(formData) {
        var data = {
            company_name: formData.value.company_name,
            permit_issue_date: formData.value.permit_issue_date.formatted,
            permit_expiry_date: formData.value.permit_expiry_date.formatted,
            visa_issue_date: formData.value.visa_issue_date.formatted,
            visa_expiry_date: formData.value.visa_expiry_date.formatted,
            arrival_date: formData.value.arrival_date.formatted,
            visa_status_id: formData.value.visa_status_id
        };
        // alert(this.node);
        // alert(this.CompanyVisa.visa_id);
        // alert(data.company_name);
        this.apiService.update(this.node, [this.CompanyVisa.visa_id], data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form1');
                    } else {
                        alert('Success: Company updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form2')
            );
    }



    search(event) {
        this.apiService.getUsingQuery('company', 'search=' + event.query + '&search_field=company_name')
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.results = [{}]
                } else {
                    this.results = response.json().data;
                }
            })
    }


    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}


// WEBPACK FOOTER //
// ./src/app/company-visa/company-visa-edit.component.ts